/**
 * Provides the basic APIs related to target map
 */
interface ActionTargetModel {
  [key: string]: {
    actions: string[];
    [key: string]: unknown;
  };
}

class TargetMap {
  /**
   * Returns the view container name associated with action
   * @param action name of the action
   */

  static actionsTargetMap = new Map();

  static getTargetViewContainerName = (action: string) => {
    if (action) {
      const normalizedAction = action.toLowerCase();
      let vcName = 'primary';
      if (this.actionsTargetMap.has(normalizedAction)) {
        vcName = this.actionsTargetMap.get(normalizedAction);
      }
      return vcName;
    }
    return '';
  };

  /**
   * builds the action target map by using the action target model
   * @param actionTargetModel is action target model
   */
  static buildActionTargetMap = (actionTargetModel?: ActionTargetModel) => {
    if (actionTargetModel) {
      Object.keys(actionTargetModel).forEach((vcName) => {
        const actionsObj = actionTargetModel[vcName];
        if (actionsObj && actionsObj.actions) {
          actionsObj.actions.forEach((action: string) => {
            this.actionsTargetMap.set(action.toLowerCase(), vcName);
          });
        }
      });
    }
  };
}

export default TargetMap;
